import styled from "styled-components";

export const InfoList = styled.ul`
  gap: 32px;
  display: flex;
  padding: 16px;
  flex-direction: column;
`;
